import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, useContext } from "react";
import { useSui } from "../../hooks/sui/useSui";
import { SuiConnector } from "../types/sui";
import { ConnectWalletResult, SuiWallet } from "../types/wallet";

export interface ISuiContextData {
  connectSui: UseMutationResult<
    ConnectWalletResult<ChainType.SUI>,
    unknown,
    {
      wallet: SuiWallet;
    },
    unknown
  >;
  disconnectSui: () => Promise<void>;
  autoConnectSui: () => Promise<void>;
  signer: SuiConnector | undefined;
  wallets: SuiWallet[];
}

export const SuiContext = createContext<ISuiContextData | undefined>(undefined);

export const SuiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const suiContext = useSui();

  return (
    <SuiContext.Provider value={suiContext}>{children}</SuiContext.Provider>
  );
};

export const useSuiContext = (): ISuiContextData => {
  const context = useContext(SuiContext);
  if (!context) {
    throw new Error("useSuiContext must be used within a SuiProvider");
  }
  return context;
};
